var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comments-box"},[_c('CommentsList',{attrs:{"entityId":_vm.entityId,"entityType":_vm.entityType,"parentId":null,"open":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }